<div class="flex flex-col w-full h-full bg-white overflow-hidden">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <!-- HEADER -->
  <div class="flex justify-between items-start p-6 border-b border-gray-200">
    <div class="flex items-center gap-4 min-w-0">
      <div
        class="w-16 h-16 rounded-2xl bg-gray-200 overflow-hidden flex items-center justify-center shrink-0"
      >
        @if (previewUrl) {
          <img [src]="previewUrl" class="w-full h-full object-cover" alt="" />
        } @else {
          <span class="text-lg font-semibold text-gray-700">
            {{
              (customerForm.get("firstName")?.value?.charAt(0) || "") +
                (customerForm.get("lastName")?.value?.charAt(0) || "")
            }}
          </span>
        }
      </div>

      <div class="flex flex-col min-w-0">
        <span
          class="text-xs text-purple-700 bg-purple-50 px-3 py-1 rounded-full w-fit mb-2"
        >
          Customer CRM
        </span>

        <h2 class="text-xl md:text-2xl font-semibold text-gray-900 truncate">
          {{
            customerForm.get("firstName")?.value ||
            customerForm.get("lastName")?.value
              ? (customerForm.get("firstName")?.value || "") +
                " " +
                (customerForm.get("lastName")?.value || "")
              : modalTitle
          }}
        </h2>

        <p class="text-sm text-gray-600 truncate">
          {{
            customerForm.get("email")?.value || "No email address entered yet"
          }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="w-9 h-9 rounded-full border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50"
      (click)="onClose()"
    >
      ×
    </button>
  </div>

  <!-- KPI CARDS -->
  <div
    class="grid grid-cols-2 md:grid-cols-4 gap-3 p-6 border-b border-gray-200"
  >
    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Customer Status</span>

      <strong class="text-lg font-semibold text-gray-900">
        {{ isEditMode ? "Existing" : "New" }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">CRM Segment</span>

      <strong class="text-lg font-semibold text-gray-900">
        {{ customerForm.get("member_level")?.value || "Standard" }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Preferred Services</span>

      <strong class="text-lg font-semibold text-gray-900">
        {{
          customerForm.get("preferred_services")?.value
            ? "Configured"
            : "Not set"
        }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Profile Image</span>

      <strong class="text-lg font-semibold text-gray-900">
        {{ previewUrl ? "Uploaded" : "Pending" }}
      </strong>
    </div>
  </div>

  <!-- TABS -->
  <div class="flex gap-2 overflow-x-auto p-4 border-b border-gray-200 bg-white">
    <button
      *ngFor="let tab of tabs"
      type="button"
      class="px-4 py-2 rounded-3xl border text-sm whitespace-nowrap"
      [class.bg-gray-950]="activeTab === tab.key"
      [class.text-white]="activeTab === tab.key"
      [class.border-gray-950]="activeTab === tab.key"
      [class.bg-white]="activeTab !== tab.key"
      [class.text-gray-700]="activeTab !== tab.key"
      [class.border-gray-200]="activeTab !== tab.key"
      (click)="activeTab = tab.key"
    >
      {{ tab.label }}
    </button>
  </div>

  <!-- BODY -->
  <form
    class="flex-1 overflow-y-auto p-6 flex flex-col gap-6"
    [formGroup]="customerForm"
    (ngSubmit)="handleSubmit()"
  >
    <!-- OVERVIEW -->
    @if (activeTab === "overview") {
      <section class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Personal Information
          </h3>

          <div class="grid gap-4">
            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                First Name *
              </span>

              <input
                type="text"
                class="input"
                placeholder="Olivia"
                formControlName="firstName"
                [class.!border-red-500]="!checkValidField('firstName')"
              />

              <span class="error" *ngIf="!checkValidField('firstName')">
                First Name is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Last Name *
              </span>

              <input
                type="text"
                class="input"
                placeholder="Rhye"
                formControlName="lastName"
                [class.!border-red-500]="!checkValidField('lastName')"
              />

              <span class="error" *ngIf="!checkValidField('lastName')">
                Last Name is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700"> Birthday </span>

              <input type="date" class="input" formControlName="birthday" />
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Member Level
              </span>

              <select class="input" formControlName="member_level">
                <option value="">Choose level</option>
                <option value="Bronze">Bronze</option>
                <option value="Silver">Silver</option>
                <option value="Gold">Gold</option>
                <option value="VIP">VIP</option>
              </select>
            </label>
          </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Contact Details
          </h3>

          <div class="grid gap-4">
            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Email Address *
              </span>

              <input
                type="email"
                class="input disabled:bg-gray-100 disabled:text-gray-500"
                formControlName="email"
                placeholder="customer@email.com"
                [class.!border-red-500]="!checkValidField('email')"
              />

              <span class="error" *ngIf="!checkValidField('email')">
                Email is required
              </span>
            </label>

            <div class="w-full">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Phone Number *
              </label>

              <ngx-intl-tel-input
                class="block w-full"
                [cssClass]="customCssClass"
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name,
                ]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.UnitedStates"
                [maxLength]="15"
                [phoneValidation]="true"
                [separateDialCode]="separateDialCode"
                [numberFormat]="PhoneNumberFormat.National"
                name="phone"
                formControlName="phone_number"
              >
              </ngx-intl-tel-input>

              <small
                *ngIf="!checkValidField('phone_number')"
                class="text-red-500"
              >
                Invalid Phone Number
              </small>
            </div>

            @if (!isEditMode) {
              <label class="flex flex-col gap-1 relative">
                <span class="text-sm font-medium text-gray-700">
                  Password *
                </span>

                <div class="relative">
                  <input
                    [type]="passwordFieldType"
                    class="input pr-10"
                    formControlName="password"
                    [placeholder]="
                      passwordFieldType === 'password'
                        ? '********'
                        : 'Enter password'
                    "
                    [class.!border-red-500]="!checkValidField('password')"
                  />

                  <button
                    type="button"
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
                    (click)="togglePasswordVisibility()"
                  >
                    <ng-container *ngIf="passwordFieldType === 'password'">
                      <img
                        [src]="assetUrl + 'icons/eye-open.svg'"
                        class="w-6 h-6"
                      />
                    </ng-container>

                    <ng-container *ngIf="passwordFieldType === 'text'">
                      <img
                        [src]="assetUrl + 'icons/eye-closed.svg'"
                        class="w-6 h-6"
                      />
                    </ng-container>
                  </button>
                </div>
              </label>
            }
          </div>
        </div>
      </section>
    }

    <!-- CRM -->
    @if (activeTab === "crm") {
      <section class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            CRM Preferences
          </h3>

          <div class="grid gap-4">
            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Preferred Staff
              </span>

              <input
                type="text"
                class="input"
                placeholder="Optional"
                formControlName="preferred_staff"
              />
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Preferred Services
              </span>

              <input
                type="text"
                class="input"
                placeholder="Haircut, manicure, facial..."
                formControlName="preferred_services"
              />
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Assigned Salon *
              </span>

              <select
                formControlName="salon_id"
                class="input form-control w-full"
                [ngClass]="
                  checkValidField('salon_id') ? '' : 'border-1 border-red-500'
                "
              >
                <option value="">Choose Salon</option>

                @for (salon of salons; track salon.salon_id) {
                  <option [value]="salon.salon_id">
                    {{ salon.name }}
                  </option>
                }
              </select>
            </label>
          </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Relationship Summary
          </h3>

          <div class="grid gap-3">
            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1"> CRM Status </span>

              <strong class="text-sm text-gray-900">
                {{ customerForm.get("member_level")?.value || "Standard" }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">
                Preferred Staff
              </span>

              <strong class="text-sm text-gray-900">
                {{
                  customerForm.get("preferred_staff")?.value || "Not configured"
                }}
              </strong>
            </div>

            <div class="border border-gray-200 rounded-lg p-3">
              <span class="block text-xs text-gray-500 pb-1">
                Preferred Services
              </span>

              <p class="text-sm text-gray-600 leading-6">
                {{
                  customerForm.get("preferred_services")?.value ||
                    "No preferred services configured."
                }}
              </p>
            </div>
          </div>
        </div>
      </section>
    }

    <!-- NOTES -->
    @if (activeTab === "notes") {
      <section class="bg-white border border-gray-200 rounded-lg p-5">
        <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
          Relationship Notes
        </h3>

        <textarea
          rows="12"
          class="input min-h-[240px]"
          placeholder="Customer preferences, allergies, preferred appointment times, upsell opportunities, reminders, conversation history..."
          formControlName="notes"
        ></textarea>
      </section>
    }

    <!-- PROFILE -->
    @if (activeTab === "profile") {
      <section class="bg-white border border-gray-200 rounded-lg p-5">
        <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
          Profile Image
        </h3>

        <div class="flex items-center gap-4 pb-6">
          <img
            [src]="previewUrl || assetUrl + 'img/avatar1.png'"
            alt="avatar"
            class="w-[88px] h-[88px] rounded-2xl object-cover border border-gray-200"
          />

          <div class="flex flex-col">
            <span class="text-sm font-medium text-gray-900">
              Customer Avatar
            </span>

            <span class="text-sm text-gray-500">
              Upload a profile image for the CRM.
            </span>
          </div>
        </div>

        <div
          class="hover:border-purple-300 hover:bg-purple-50 transition-colors cursor-pointer"
          (click)="fileInput.click()"
          (dragover)="handleDragOver($event)"
          (drop)="handleDrop($event)"
        >
          <div
            class="flex flex-col justify-center items-center border border-gray-200 rounded-xl px-4 py-5 text-center gap-3"
          >
            <img [src]="assetUrl + 'icons/upload-border.svg'" alt="" />

            <div class="text-xs">
              <span class="text-purple-brand">Click to upload</span>
              <span> or drag and drop</span>

              <p class="text-xs text-gray-400 pt-1">
                SVG, PNG, JPG or GIF max. 800x400px
              </p>
            </div>
          </div>

          <input
            #fileInput
            type="file"
            accept="image/*"
            (change)="handleFileSelect($event)"
            class="hidden"
          />
        </div>
      </section>
    }

    <!-- FOOTER -->
    <div class="sticky bottom-0 bg-white pt-4 border-t border-gray-200">
      <div class="ml-auto flex justify-end gap-3">
        <button
          type="button"
          class="px-6 py-2 shadow rounded-3xl bg-white text-gray-900 border border-gray-200"
          (click)="onClose()"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white"
        >
          {{ isEditMode ? "Save Changes" : "Create Customer" }}
        </button>
      </div>
    </div>
  </form>
</div>
